import { useNavigate, useLocation, useParams } from 'react-router-dom';

export const useNextStep = (): { nextStep: () => void } => {
  const location = useLocation();
  const navigate = useNavigate();
  const { companySlug } = useParams();

  const steps = [
    `/${companySlug}`,
    `/${companySlug}/profile`,
    `/${companySlug}/questions/personality`,
    `/${companySlug}/questions/interests/instructions`,
    `/${companySlug}/questions/interests`,
    `/${companySlug}/questions/values/instructions`,
    `/${companySlug}/questions/values`,
    // `/${companySlug}/questions/customer/instructions`,
    // `/${companySlug}/questions/customer`,
    `/${companySlug}/results-intro`,
    `/${companySlug}/results-overview`,
    // `/${companySlug}/personality-results`,
    // `/${companySlug}/interests-results`,
    // `/${companySlug}/thank-you`,
  ];

  // the two steps removed are no longer used due to removing the id from local storage, maybe we can
  // move the contents of those pages to the thank you page.

  const currentIndex = steps.indexOf(location.pathname);
  let nextIndex = currentIndex + 1;

  if (nextIndex >= steps.length) {
    nextIndex = 0;
  }

  const nextStep = () => {
    // Preserve URL search parameters when navigating
    const searchParams = location.search;
    navigate(steps[nextIndex] + searchParams);
  };
  return { nextStep };
};
